export const findFieldByAbsolutePath = (group, absolutePath) => {
    let field;
    group.fields.forEach(fields => {
        field = fields.find(f => f.absolutePath && f.absolutePath.includes(absolutePath));
    });
    if (!field) {
        throw Error(`field for ${absolutePath} is missing`);
    }
    else {
        return field;
    }
};
